import { render, staticRenderFns } from "./ActionRequiredPanel.vue?vue&type=template&id=abb37510&scoped=true"
import script from "./ActionRequiredPanel.vue?vue&type=script&lang=js"
export * from "./ActionRequiredPanel.vue?vue&type=script&lang=js"
import style0 from "./ActionRequiredPanel.vue?vue&type=style&index=0&id=abb37510&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb37510",
  null
  
)

export default component.exports